import React from 'react';
import { COPY } from './copy';

const OpenRequestButton = ({ onClick, disabled = false }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="btn font-semibold text-white uppercase px-4 py-2 rounded"
    style={{
      backgroundColor: disabled ? '#999' : COPY.hex.alertRed,
      cursor: disabled ? 'not-allowed' : 'pointer',
    }}
    onMouseOver={(e) => { if (!disabled) e.currentTarget.style.backgroundColor = COPY.hex.alertRedHover; }}
    onMouseOut={(e) => { if (!disabled) e.currentTarget.style.backgroundColor = COPY.hex.alertRed; }}
  >
    {COPY.buttons.openRequest}
  </button>
);

export default OpenRequestButton;
